import PT from 'prop-types';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import FinalForm from 'components/forms';
import TextField from 'components/pickers/final-form-fields/text-field';
import useEditAsset from './hooks/use-edit-asset';

// TO DO - when asset panel is removed, relocate this component to the asset navigation
const EditAsset = ({
  setOpenEditingForm,
  setAssetError,
  loading,
  asset,
  setAsset,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { sendUpdatedValues, validateEditing, openSnackBar } = useEditAsset(
    setOpenEditingForm,
    setAssetError,
    asset,
    setAsset
  );

  useEffect(() => {
    if (openSnackBar.open) {
      const title =
        openSnackBar.variant === 'success'
          ? 'Asset updated successfully'
          : `Error: ${openSnackBar.message}`;
      enqueueSnackbar(title, {
        variant: openSnackBar.variant,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSnackBar]);

  return (
    <Box
      sx={theme => ({
        padding: theme.spacing(1),
        width: '100%',
      })}
    >
      <FinalForm
        isLoading={loading}
        isPanel={true}
        resetButton={false}
        cancelButton={true}
        title="Edit Asset Name"
        initialValues={{
          newAssetName: '',
          value: asset.name,
        }}
        formFields={[
          {
            size: 20,
            field: <TextField label="New Asset Name" name="value" />,
          },
        ]}
        validate={validateEditing}
        onClose={() => {
          setOpenEditingForm(false);
          setAssetError(false);
        }}
        onSubmit={sendUpdatedValues}
      />
    </Box>
  );
};
EditAsset.propTypes = {
  setOpenEditingForm: PT.func.isRequired,
  setAssetError: PT.func.isRequired,
  setAsset: PT.func.isRequired,
  loading: PT.bool.isRequired,
  asset: PT.shape({
    id: PT.string,
    name: PT.string,
    new: PT.bool,
    assetTypeId: PT.string,
    children: PT.arrayOf(PT.string),
    deletedAt: PT.string,
    assetType: PT.shape({ assetSubType: PT.bool }),
    parent: PT.string,
    editedName: PT.string,
  }).isRequired,
};
export default EditAsset;
